import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { paymentsApi } from "./paymentsApi";

export const useKsefXml = (paymentId: number | undefined, courseId?: number) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.KSEF_XML(paymentId ?? 0, courseId),
    queryFn: () => paymentsApi.fetchKsefXml(paymentId!, courseId),
    placeholderData: keepPreviousData,
    enabled: !!paymentId,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.KSEF_XML(paymentId ?? 0, courseId),
    });
  };

  return { invalidate, isLoading, isFetching, xml: data?.data?.xml ?? null };
};
